import { createContext, useContext, useState } from "react";

interface DataChangedProviderProps {
  children: React.ReactNode;
}

type DataChangedContextType = {
  dataChanged?: boolean;
  setDataChanged: (dataChanged?: boolean) => void;
};

export const DataChangedContext = createContext<DataChangedContextType>({
  dataChanged: false,
  setDataChanged: () => {},
});

const DataChangedProvider = (props: DataChangedProviderProps) => {
  const [dataChanged, setDataChanged] = useState<boolean>();

  return (
    <DataChangedContext.Provider value={{ dataChanged, setDataChanged }}>
      {props.children}
    </DataChangedContext.Provider>
  );
};

export default DataChangedProvider;

export const useDataChanged = () => {
  const { dataChanged, setDataChanged } = useContext(DataChangedContext);
  return { dataChanged, setDataChanged };
};
